import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Gallery from '../components/Gallery';
import { getApiUrl } from '../utils/api';
import './Category.css';

function Category() {
  const { tag } = useParams();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, [tag]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const encodedTag = encodeURIComponent(tag);
      const response = await fetch(getApiUrl(`/api/projects?tag=${encodedTag}`));
      if (!response.ok) {
        throw new Error('Failed to fetch projects');
      }
      const data = await response.json();
      setProjects(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  const categoryTitle = tag.charAt(0).toUpperCase() + tag.slice(1);

  return (
    <div className="page-container">
      <div className="category-header">
        <h1>{categoryTitle}</h1>
        <p className="category-count">{projects.length} project{projects.length !== 1 ? 's' : ''}</p>
      </div>
      <Gallery projects={projects} />
    </div>
  );
}

export default Category;
